<template>
    <div>
        <el-form ref="searchForm" :model="searchData" inline>
            <el-form-item label="UID">
                <el-input v-model="searchData.user_id" size="mini" style="width: 200px;" />
            </el-form-item>
            <el-form-item label="用户手机号">
                <el-input v-model="searchData.mobile" size="mini" />
            </el-form-item>
            <el-form-item>
                <el-button size="mini" @click="handlerSearch">
                    查找
                </el-button>
            </el-form-item>
        </el-form>
        <el-table :data="datalist">
            <el-table-column
                prop="id"
                label="用户id"
                width="185px"
            />
<!--            <el-table-column
                label="用户类型"
            >
                <template slot-scope="scope">
                    {{ getType(scope.row.type) }}
                </template>
            </el-table-column>-->
            <el-table-column
                prop="nickname"
                label="联系人"
            />
            <el-table-column
                prop="inviter_user_id"
                label="邀请人"
                width="185px"
            >
                <template slot-scope="scope">
                    <span @click="handleClickDetailShowDialog(scope.row, scope.row.inviter_user_id)" v-if="scope.row.inviter_user_id === '0'">{{scope.row.inviter_user_id}}</span>
                    <span @click="handleClickDetailShowDialog(scope.row, scope.row.inviter_user_id)" style="color: #409EFF;" v-else>{{scope.row.inviter_user_id}}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="邀请渠道"
            >
                <template slot-scope="scope">
                    <span>{{ getChannel(scope.row.channel_id) }}</span>
                </template>
            </el-table-column>
            <el-table-column 
                prop="mobile"
                label="联系电话(账号)"
            />
            <el-table-column
                label="认证状态"
            >
                <template slot-scope="scope">
                    <span>{{ getUserCertificateStatus(scope.row.user_certificate_status) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="注册时间"
            >
                <template slot-scope="scope">
                    {{ scope.row.create_time }}
                </template>
            </el-table-column>
            <el-table-column
                label="上次登录时间"
            >
                <template slot-scope="scope">
                    {{ scope.row.last_login }}
                </template>
            </el-table-column>
<!--            <el-table-column
                label="财务信息"
            >
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="info"
                        @click="handleFinanceInfoShowDialog(scope.row)"
                    >查看</el-button>
                </template>
            </el-table-column>-->
            <el-table-column
                label="操作"
            >
                <template slot-scope="scope">
                    <div class="edit-btn-box">
                        <el-button size="mini" type="primary" @click="handleClickDetailShowDialog(scope.row, scope.row.id)">用户详情</el-button>
                        <el-button size="mini" type="primary" @click="handleAddRemark(scope.row.id)">添加备注</el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="remark"
                label="备注">
                <template slot-scope="scope">
                    <el-col>{{ getRemarkText(scope.row.user_latest_remark) }}</el-col>
<!--                    <el-button size="mini" class="all-remark" v-show="scope.row.user_latest_remark" @click="allRemark(scope.row.id)">查看全部</el-button>-->
                </template>
            </el-table-column>
        </el-table>
        <page-bar
            ref="pageBar"
            :pageSize="50"
            :pageSizes="pageSizes"
            :currentPageCount="datalist.length"
            @page-changed="loadData"
        ></page-bar>
        <el-dialog :visible.sync="dialogShow" title="设置佣金率和税率">
            <div class="rate_box">
                <div class="rate_box_title">佣金率选择</div>
                <el-table :data="settlement" @row-click="handleSettlementRowClick">
                    <el-table-column width="55px">
                        <template slot-scope="scope">
                            <el-icon class="el-icon-success" v-if="scope.row.id === settlementId" style="font-size: 20px;color: #409eff;"></el-icon>
                            <el-icon color="#409EFC" class="el-icon-circle-check" v-else style="font-size: 20px;"></el-icon>
                        </template>
                    </el-table-column>
                    <el-table-column prop="id" label="id" width="100px" />
                    <el-table-column prop="name" label="名称" width="200px" />
                    <el-table-column label="佣金率">
                        <template slot-scope="scope">
                            <div class="rate-box">
                                <span>默认：{{ forMatterRate(scope.row.rates.default) }}</span>
                                <span>YB：{{ forMatterRate(scope.row.rates.iyunfu) }}</span>
                                <span>HZ：{{ forMatterRate(scope.row.rates.qixin) }}</span>
                                <span>YS：{{ forMatterRate(scope.row.rates.niubao) }}</span>
                                <span>WT：{{ forMatterRate(scope.row.rates.fengqi) }}</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="rate_box_title">税率</div>
                <el-table :data="tax" @row-click="handleTaxRowClick">
                    <el-table-column width="55px">
                        <template slot-scope="scope">
                            <el-icon class="el-icon-success" v-if="scope.row.id === taxId" style="font-size: 20px;color: #409eff;"></el-icon>
                            <el-icon color="#409EFC" class="el-icon-circle-check" v-else style="font-size: 20px;"></el-icon>
                        </template>
                    </el-table-column>
                    <el-table-column prop="id" label="id" width="100px" />
                    <el-table-column prop="name" label="名称" width="200px" />
                    <el-table-column label="佣金率">
                        <template slot-scope="scope">
                            <div class="rate-box">
                                <span>{{ forMatterRate(scope.row.rate) }}</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;margin-top: 20px;">
                <el-button type="info" size="small" @click="dialogShow = !dialogShow">取消</el-button>
                <el-button type="primary" size="small" @click="dialogVisible = !dialogVisible">保存</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <span>确认保存此次修改吗?</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible  = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="financeDialogShow" :before-close="handleFinanceDialogClose">
            <el-form label-position="right">
                <el-form-item label="账户名：" label-width="150px">
                    <el-input v-model="financeConfig.bank_account_name" disabled></el-input>
                </el-form-item>
                <el-form-item label="银行卡号：" label-width="150px">
                    <el-input v-model="financeConfig.bank_card_id" disabled></el-input>
                </el-form-item>
                <el-form-item label="银行：" label-width="150px">
                    <el-input v-model="financeConfig.opening_bank" disabled></el-input>
                </el-form-item>
                <el-form-item label="开户行：" label-width="150px">
                    <el-input v-model="financeConfig.opening_bank_detail" disabled></el-input>
                </el-form-item>
                <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;">
                    <el-button type="primary" size="small" @click="financeDialogShow = !financeDialogShow">确定</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <span>确认保存此次修改吗?</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible  = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="detailDialogShow" :before-close="handleDetailDialogClose" destroy-on-close :modal-append-to-body="false">
            <UserDetail :userId="userId" @handleDetailDialogClose="handleDetailDialogClose"></UserDetail>
        </el-dialog>
        <el-dialog :visible.sync="imageViewDialogShow" :before-close="handleImageViewDialogClose">
            <div style="display: flex;flex-direction: row;align-items: center;justify-content: center;width: 80%; margin: 0 auto;">
                <img :src="`data:image/*;base64,${imageUrl}`" alt="" style="max-width: 380px;height: auto;">
            </div>
        </el-dialog>

        <el-dialog :visible.sync="showRemarks" title="添加备注" @close="cancelRemarks">
            <el-input
                type="textarea"
                :rows="3"
                placeholder="输入备注内容，最多100字"
                v-model="remarkTextarea"
            >
            </el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelRemarks">取 消</el-button>
                <el-button type="primary" @click="updateRemarks">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="全部备注" :visible.sync="showRemarkList">
            <el-table :data="remarkList">
                <el-table-column
                    prop="update_time"
                    label="备注时间"
                />
                <el-table-column
                    prop="operator"
                    label="添加人"
                />
                <el-table-column
                    prop="content"
                    label="备注内容"
                />
            </el-table>
            <div slot="footer" class="dialog-footer">
<!--                <el-button @click="showRemarkList = false">取 消</el-button>-->
                <el-button type="primary" @click="showRemarkList = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import request from '@/api/request.js'
import dateFormat from '@/util/date.js'
import PageBar from '../ui/PageBar'
import UserDetail from '@/modules/saas/UserDetail.vue'
export default {
    components: {
        PageBar,
        UserDetail
    },
    data(){
        return {
            searchData: {
                user_id: '',
                mobile: ''
            },
            filter: {},
            pageSizes: [10, 20, 50],
            currentRange: [0, 50],
            dialogShow: false,
            dialogVisible: false,
            datalist: [],
            listItem: {},
            typeOptions: [],
            commission_rate: null,
            tax_rate: null,
            financeDialogShow: false,
            detailDialogShow: false,
            imageViewDialogShow: false,
            financeConfig: {},
            uStatusOptions: ['审核中',  '认证成功', '认证失败', '未认证'],
            uTypeOptions: ['未认证',  '个人用户', '企业用户'],
            front_url: '',
            back_url: '',
            company_license_url: '',
            channelList: [],
            userCertificationOpt: ['审核中', '认证成功', '认证失败', '未认证'],
            detailItem: {},
            imageUrl: '',
            showRemarks: false,
            showRemarkList: false,
            createRemarkType: false,
            remarkList: [],
            remarkTextarea: "",
            currentUserId: '',
            rate: {},
            settlementRateTemplate: {},
            taxRateTemplate: {},
            settlement: [],
            tax: [],
            settlementId: null,
            taxId: null,
            currentId: null
        }
    },
    computed: {
        userId: {
            get(){
                return this.currentId
            },
            set(){

            }
        }
    },
    created() {
        this.getChannelList()
        this.loadData([0, 50])
    },
    mounted() {
        this.getTypeOptions()  
    },
    methods: {
        loadData(range){
            this.currentRange = range
            request.saas
                .post('uc/get_user_list', { 
                    range: range,
                    filter: this.filter
                })
                .then(r => {
                    this.datalist = r.data.list
                })
        },
        handlerSearch() {
            let filter = {}
            if (this.searchData.user_id) {
                filter.user_id = this.searchData.user_id.toString()
            }
            if (this.searchData.mobile) {
                filter.mobile = this.searchData.mobile.toString()
            }
            this.filter = filter
            this.loadData(this.currentRange)
        },
        getChannelList(){
            request.saas
                .post('uc/invite/get_channel_list', {range: this.currentRange})
                .then(r => {
                    this.channelList = r.data.list
                })
        },
        handleAddRemark: function (id) {
            this.showRemarks = true
            this.currentUserId = id
        },
        allRemark (id) {
            this.currentUserId = id
            this.getRemarkList()
        },
        getRemarkList: async function () {
            await request.saas.post("uc/get_user_remark_list", {
                user_id: this.currentUserId
            }).then(resp => {
                this.remarkList = resp.data.list
                this.showRemarkList = true
            })
        },
        cancelRemarks() {
            this.createRemarkType = false
            this.showRemarks = false
            this.remarkTextarea = ""
        },
        async updateRemarks() {
            if (!this.createRemarkType) {
                this.createRemarkType = true
                if (!this.remarkTextarea) {
                    this.$message.info("请输入内容")
                    this.createRemarkType = false
                } else if (this.remarkTextarea.length > 100) {
                    this.$message.info("最多100字")
                    this.createRemarkType = false
                } else{
                    await request.saas.post("uc/create_user_remark", {
                        user_id: this.currentUserId,
                        content: this.remarkTextarea,
                        type: 1
                    })
                    this.$message.success("提交成功")
                    this.showRemarks = false
                    this.remarkTextarea = ""
                    this.currentUserId = ""
                    this.createRemarkType = false
                    this.loadData(this.currentRange)
                }
            }
        },
        previewImage(url){
            this.imageUrl = url
            this.imageViewDialogShow = !this.imageViewDialogShow
        },
        handleClickDetailShowDialog(item, id){
            const { href } = this.$router.resolve({ path: `/saas/saas_user_edit/${id}` });
            window.open(href, "_blank")
            return
            this.currentId = id
            if(id === '0') return
            this.handleFinanceInfoShowDialog(item)
            this.listItem = item
            //获取佣金率和税率
            request.saas
                .post('settlement/get_user_settlement_config', {
                    user_id: this.listItem.id
                })
                .then(res => {
                    this.rate = res.data
                    this.settlementRateTemplate.id = res.data.settlement_rate_template.id
                    this.settlementRateTemplate.name = res.data.settlement_rate_template.name
                    this.settlementRateTemplate.default = res.data.settlement_rate_template.rates.default
                    this.settlementRateTemplate.iyunfu = res.data.settlement_rate_template.rates.iyunfu
                    this.settlementRateTemplate.qixin = res.data.settlement_rate_template.rates.qixin
                    this.settlementRateTemplate.niubao = res.data.settlement_rate_template.rates.niubao
                    this.settlementRateTemplate.fengqi = res.data.settlement_rate_template.rates.fengqi
                    this.settlementRateTemplate.create_time = res.data.settlement_rate_template.create_time
                    this.taxRateTemplate.id = res.data.tax_rate_template.id
                    this.taxRateTemplate.name = res.data.tax_rate_template.name
                    this.taxRateTemplate.rate = res.data.tax_rate_template.rate
                    this.taxRateTemplate.create_time = res.data.tax_rate_template.create_time
                    this.taxId = res.data.tax_rate_template.id
                    this.settlementId = res.data.settlement_rate_template.id
                })
            request.saas.post("uc/get_user_detail", {
                id: id
            })
                .then(resp => {
                    this.detailItem = resp.data
                    this.detailItem.id = resp.data.id
                    this.detailItem.type = resp.data.user_info.type
                    this.detailItem.name = resp.data.user_info.name
                    this.detailItem.nickname = resp.data.user_info.nickname
                    this.detailItem.mobile = resp.data.user_info.mobile
                    this.detailItem.last_login = resp.data.user_info.last_login
                    this.detailItem.create_time = resp.data.user_info.create_time
                    
                    this.detailItem.company_id = resp.data.user_certificate_info.company_id
                    //this.detailItem.company_license_url = resp.data.user_certificate_info.company_license_url
                    this.detailItem.company_name = resp.data.user_certificate_info.company_name
                    this.detailItem.extra = resp.data.user_certificate_info.extra
                    this.detailItem.id_card = resp.data.user_certificate_info.id_card
                    
                    this.detailItem.last_apply_time = resp.data.user_certificate_info.last_apply_time
                    this.detailItem.last_audit_time = resp.data.user_certificate_info.last_audit_time
                    this.detailItem.uName = resp.data.user_certificate_info.name || '--'
                    this.detailItem.uStatus = resp.data.user_certificate_info.status
                    this.detailItem.uType = resp.data.user_certificate_info.type
                    this.detailItem.fatal_reason = resp.data.user_certificate_info.extra.fatal_reason
                    this.detailItem.company_platform_name = resp.data.user_certificate_info.extra.company_platform_name
                    this.detailItem.company_remark = resp.data.user_certificate_info.extra.company_remark
                    this.detailItem.person_certificate_id = resp.data.user_certificate_info.extra.person_certificate_id
                    this.detailItem.person_organization_name = resp.data.user_certificate_info.extra.person_organization_name

                    if(resp.data.user_certificate_info.company_license_url) {
                        //企业用户,个人用户没有营业执照
                        this.getIdentityPhoto(3,resp.data.user_certificate_info.company_license_url)
                    }
                    if(resp.data.user_certificate_info.id_card_front_url) {
                        this.getIdentityPhoto(1,resp.data.user_certificate_info.id_card_front_url)
                    }
                    if(resp.data.user_certificate_info.id_card_front_url) {
                        this.getIdentityPhoto(2,resp.data.user_certificate_info.id_card_back_url)
                    }
                    
                })
            this.$nextTick(() => {
                this.handleUserDetailDialogShow()
            })
        },
        handleUserDetailDialogShow(){
            this.detailDialogShow = !this.detailDialogShow
        },
        getChannel(channel){
            for(let i in this.channelList) {
                if(channel === this.channelList[i].id){
                    return this.channelList[i].name
                }
            }
        },
        getUserCertificateStatus(status){
            return this.userCertificationOpt[status-1]
        },
        getTypeOptions(){
            request.saas
                .post('user_type_list', {})
                .then(resp => {
                    this.typeOptions = resp.data.list
                })
        },
        save(){
            //设置佣金率和税率
            let data = {
                user_id: this.detailItem.id,
                settlement_rate_template_id: this.settlementId,
                tax_rate_template_id: this.taxId
            }
            request.saas
                .post('settlement/update_user_settlement_config', data)
                .then(() => {
                    this.$message.success('修改成功')
                    this.dialogVisible = !this.dialogVisible
                    this.dialogShow = !this.dialogShow
                    this.detailDialogShow = !this.detailDialogShow
                    this.loadData(this.currentRange)
                })
            /*let data = {
                user_id: this.listItem.id,
                commission_rate: Number(this.commission_rate),
                tax_rate: Number(this.tax_rate),
                operator: 'unknown'
            }
            request.saas
                .post('uc/settlement/update_user_settlement_rate', data)
                .then(() => {
                    this.$message.success('修改成功')
                    this.dialogVisible = !this.dialogVisible
                    this.dialogShow = !this.dialogShow
                    this.loadData(this.currentRange)
                })*/
        },
        getIdentityPhoto(type, filename){
            request.saas.post("common/get_private_object", {
                filename: filename
            }).then(res => {
                if(type === 1) {
                    this.front_url = res.data.content
                } else if(type === 2) {
                    this.back_url = res.data.content
                } else if(type === 3) {
                    this.company_license_url = res.data.content
                }
            })
        },
        handleClose(){
            this.dialogVisible = !this.dialogVisible
        },
        handleShowDialog(item){
            this.listItem = item
            request.saas
                .post('settlement/get_settlement_rate_template_list', {
                    range: [0, 50],
                })
                .then(r => {
                    this.settlement = r.data.list
                })
            request.saas
                .post('settlement/get_tax_rate_template_list', {
                    range: [0, 50],
                })
                .then(r => {
                    this.tax = r.data.list
                })

            this.dialogShow = !this.dialogShow
        },
        handleFinanceInfoShowDialog(item){
            request.saas
                .post('uc/settlement/get_user_finance_config', {
                    user_id: item.id
                })
                .then(res => {
                    this.financeConfig = res.data
                    //this.handleFinanceDialogClose()
                })
        },
        handleFinanceDialogClose(){
            this.financeDialogShow = !this.financeDialogShow
        },
        handleDetailDialogClose(){
            this.back_url = ''
            this.front_url = ''
            this.company_license_url = ''
            this.listItem = {}
            this.detailDialogShow = !this.detailDialogShow
        },
        handleImageViewDialogClose(){
            this.imageViewDialogShow = !this.imageViewDialogShow
            this.imageUrl = ''
        },
        forMatter(time){
            let date = new Date(time*1000);
            return dateFormat("YYYY-mm-dd HH:MM:SS", date)
        },
        getType(type) {
            for (const opt of this.typeOptions) {
                if(type === opt.value) {
                    return opt.desc
                }
            }
        },
        getUType(type){
            return this.uTypeOptions[type]
        },
        getUStatus(status) {
            return this.uStatusOptions[status-1]
        },
        getTitleName(uType) {
            return uType === 1 ? '姓名:': uType === '2' ? '法人姓名:' : ''
        },
        getTitleIdentity(uType) {
            return uType === 1 ? '身份证号:': uType === '2' ? '法人证件号:' : ''
        },
        getRemarkText: function (remark) {
            if (remark) {
                if (remark.length > 50) {
                    return remark.slice(0, 50) + '...'
                } else {
                    return remark
                }
            } else {
                return ''
            }
        },
        forMatterRate(rate){
            return (rate/100).toFixed(2) + '%'
        },
        handleSettlementRowClick(row){
            this.settlementId = row.id
        },
        handleTaxRowClick(row){
            this.taxId = row.id
        }
    }
}
</script>
<style scoped>
.box{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
}
.box div{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.box div span{
    color: #191919;
    font-size: 14px;
    margin: 14px 0;
}
.box div img{
    width: 140px;
    height: 100px;
}
.edit-btn-box{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

}
.edit-btn-box .el-button{
    margin-bottom: 2px;
    margin-left: 0;
    width: 90px;
}
.detail_rate_box{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
}
.detail_rate_box div{
    width: 50%;
}
.rate_box_title{
    margin: 10px 0;
    font-weight: 500;
    font-size: 16px;
}
.rate-box span{
    margin-right: 10px;
}
</style>
